import React, { Component } from 'react'
import { connect } from 'react-redux';
let RealEntityAdminMenu = null;

class EntityAdminMenu extends Component {
  	constructor(props) {
    	super(props);
    	this.state = { isReady: RealEntityAdminMenu !== null };
  	}

  	componentDidMount() {
  		const {isEditor} = this.props
  		
  		if(!isEditor) return
  		this.load()
  	}

	componentWillReceiveProps({isEditor}) {
		if(isEditor && !RealEntityAdminMenu) this.load()
	}

  	load() {
    	require.ensure('./admin', () => {
      		RealEntityAdminMenu = require('./admin').RealEntityAdminMenu;
      		if (!this.hasUnmounted) {
        		this.setState({ isReady: true });
      		}
    	});
  	}

  	componentWillUnmount() {
    	this.hasUnmounted = true;
  	}

  	render() {
  		return this.state.isReady ? <RealEntityAdminMenu  {...this.props}/> : null;
  	}
}
export default connect(state => ({isEditor: state.auth.isEditor}))(EntityAdminMenu);



// WEBPACK FOOTER //
// ./src/fm/admin/EntityAdminMenu.js